export function AccordionSchemaEnhancer({ schema, formData, intl }) {
  // Shadows AccordionSchemaEnhancer from VLT
  // Opinionated change of the options fieldset
  schema.fieldsets = schema.fieldsets.filter((item) => item.id !== 'options');
  schema.fieldsets = [
    ...schema.fieldsets,
    {
      id: 'options',
      title: 'Optionen',
      fields: [
        // 'headline',
        // 'title',
        // 'title_size',
        // 'right_arrows',
        'collapsed',
        'non_exclusive',
        // 'filtering',
      ],
    },
  ];

  // Some other opinionated defaults
  schema.required = [];
  schema.properties.right_arrows.default = true;
  schema.properties.collapsed.default = false;
  schema.properties.non_exclusive.default = false;

  return schema;
}
